import type { QueryClient } from '@tanstack/react-query';
import type { AuthStore } from './auth-store';
import { forgetTour } from './forget-tour';

/**
 * What this browser fetched for one person is gone once they sign out or their session ends, or another person
 * signs in (tenant isolation audit 2026-10-11). Sign-out moves to `/sign-in` without reloading the page, and the
 * route loaders answer from the cache when it holds the query, so the next person to sign in on a shared computer
 * was shown the last person's jobs until the refetch. The workbench tour's place and flags go too (`forget-tour.ts`).
 * Returns the unsubscribe.
 */
export function forgetOnSignOut(auth: AuthStore, queryClient: QueryClient): () => void {
  let who = auth.getState().principal?.id ?? null;
  return auth.subscribe(() => {
    const now = auth.getState().principal?.id ?? null;
    if (who !== null && now !== who) {
      queryClient.clear();
      forgetTour();
    }
    who = now;
  });
}
